import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { UpdateCarretaProprietarioByPlacaBody } from 'src/app/services/CarretaService/carreta.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import { UpdateCavaloProprietarioByPlacaBody } from 'src/app/services/CavaloService/cavalo.model';

@Component({
  selector: 'app-modal-vincular-cavalo-carreta',
  templateUrl: './modal-vincular-cavalo-carreta.component.html',
  styleUrls: ['./modal-vincular-cavalo-carreta.component.scss']
})
export class ModalVincularCavaloCarretaComponent {
  form: FormGroup;
  isLoading: boolean = false;
  guid = generateUUID();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalVincularCavaloCarretaComponent>,
    private fb: FormBuilder,
    private cavaloService: CavaloService,
    private carretaService: CarretaService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      TX_PLCA_CRRT: [null],
      TX_PLCA_CAVA: [null],
      FK_EPSA: [this.data.FK_EPSA],
      FK_MTRT_EXTR: [this.data.FK_MTRT_EXTR]
    });
    return form;
  }

  postVinculacao(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const placaCarreta = this.form.controls['TX_PLCA_CRRT'].value;
    if (placaCavalo && placaCarreta) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Realize apenas uma vinculação por vez de cavalo ou carreta.',
        'warning'
      );
      return;
    }
    if (placaCavalo) {
      this.postVinculacaoCavalo();
      return;
    }
    if (placaCarreta) {
      this.postVinculacaoCarreta();
      return;
    }
  }

  postVinculacaoCavalo(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.cavaloService.UpdateCavaloProprietarioByPlaca(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }

  postVinculacaoCarreta(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.carretaService.UpdateCarretaProprietarioByPlaca(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }

  createPayload():
    | UpdateCavaloProprietarioByPlacaBody
    | UpdateCarretaProprietarioByPlacaBody
    | any {
    return {
      ...this.form.value
    };
  }

  onCancelar(): void {
    this.dialogRef.close();
  }
}
